(function () {
  var BADGES = ['', 'MÁS POPULAR', 'MEJOR VALOR'];

  function formatPrice(cents) {
    return '$' + Math.floor(cents / 100).toLocaleString('es-MX') + ' MXN';
  }

  function extractQty(title) {
    var match = title.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function buildCard(variant, index, isSelected, onSelect) {
    var card = document.createElement('div');
    card.className = 'bundle-picker__card' + (isSelected ? ' bundle-picker__card--selected' : '');

    var qty = extractQty(variant.title);
    var pricePerUnit = qty > 1 ? Math.round(variant.price / qty) : null;
    var badge = BADGES[index] || '';

    var radio = document.createElement('div');
    radio.className = 'bundle-picker__radio';

    var info = document.createElement('div');
    info.className = 'bundle-picker__info';

    var units = document.createElement('span');
    units.className = 'bundle-picker__units';
    units.textContent = variant.title;

    if (badge) {
      var badgeEl = document.createElement('span');
      badgeEl.className = 'bundle-picker__badge';
      badgeEl.textContent = badge;
      units.appendChild(badgeEl);
    }

    info.appendChild(units);

    var prices = document.createElement('div');
    prices.className = 'bundle-picker__prices';

    var priceEl = document.createElement('span');
    priceEl.className = 'bundle-picker__price';
    priceEl.textContent = formatPrice(variant.price);
    prices.appendChild(priceEl);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var compareEl = document.createElement('span');
      compareEl.className = 'bundle-picker__compare';
      compareEl.textContent = '$' + Math.floor(variant.compare_at_price / 100).toLocaleString('es-MX');
      prices.appendChild(compareEl);
    }

    if (pricePerUnit) {
      var perEl = document.createElement('span');
      perEl.className = 'bundle-picker__per';
      perEl.textContent = '$' + Math.floor(pricePerUnit / 100).toLocaleString('es-MX') + ' c/u';
      prices.appendChild(perEl);
    }

    card.appendChild(radio);
    card.appendChild(info);
    card.appendChild(prices);

    card.addEventListener('click', function () {
      onSelect(card, variant);
    });

    return card;
  }

  function syncVariantSelect(fieldset, variantTitle) {
    // Button/pill picker — radio inputs
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === variantTitle) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
    // Dropdown picker — select element
    var selects = fieldset.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var opts = selects[j].options;
      for (var k = 0; k < opts.length; k++) {
        if (opts[k].value === variantTitle) {
          selects[j].value = opts[k].value;
          selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }
  }

  function initBundlePicker() {
    var variantSelects = document.querySelectorAll('variant-selects');

    variantSelects.forEach(function (vs) {
      // Skip if product uses swatch pickers (color/size options)
      if (vs.querySelector('.product-form__input--swatch')) return;

      var fieldset = vs.querySelector('.product-form__input--pill');
      if (!fieldset) return;

      var dataEl = vs.querySelector('script[type="application/json"]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      // Only enhance when variants look like quantity bundles (title contains a number)
      var looksLikeBundles = variants.some(function (v) {
        return /\d/.test(v.title);
      });
      if (!looksLikeBundles || variants.length < 2) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'bundle-picker';

      function onSelect(clickedCard, variant) {
        wrapper.querySelectorAll('.bundle-picker__card').forEach(function (c) {
          c.classList.remove('bundle-picker__card--selected');
        });
        clickedCard.classList.add('bundle-picker__card--selected');
        syncVariantSelect(fieldset, variant.title);
      }

      variants.forEach(function (variant, index) {
        var card = buildCard(variant, index, index === 0, onSelect);
        wrapper.appendChild(card);
      });

      // Insert before the fieldset, hide fieldset but keep it in DOM for form submission
      fieldset.parentNode.insertBefore(wrapper, fieldset);
      fieldset.style.position = 'absolute';
      fieldset.style.opacity = '0';
      fieldset.style.pointerEvents = 'none';
      fieldset.style.height = '0';
      fieldset.style.overflow = 'hidden';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlePicker);
  } else {
    initBundlePicker();
  }
})();
